import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Horoscope from "./pages/Horoscope";
import HoroscopoChino from "./pages/HoroscopoChino";
import Compatibility from "./pages/Compatibility";
import Tarot from "./pages/Tarot";
import NotFound from "./pages/NotFound";
import HoroscopoAries from "./pages/HoroscopoAries";
import HoroscopoRata from "./pages/HoroscopoRata";
import HoroscopoBuey from "./pages/HoroscopoBuey";
import HoroscopoTigre from "./pages/HoroscopoTigre";
import HoroscopoConejo from "./pages/HoroscopoConejo";
import HoroscopoDragon from "./pages/HoroscopoDragon";
import HoroscopoSerpiente from "./pages/HoroscopoSerpiente";
import HoroscopoCaballo from "./pages/HoroscopoCaballo";
import HoroscopoCabra from "./pages/HoroscopoCabra";
import HoroscopoMono from "./pages/HoroscopoMono";
import HoroscopoGallo from "./pages/HoroscopoGallo";
import HoroscopoPerro from "./pages/HoroscopoPerro";
import HoroscopoCerdo from "./pages/HoroscopoCerdo";
import HoroscopoTauro from "./pages/HoroscopoTauro";
import HoroscopoGeminis from "./pages/HoroscopoGeminis";
import HoroscopoCancer from "./pages/HoroscopoCancer";
import HoroscopoLeo from "./pages/HoroscopoLeo";
import HoroscopoVirgo from "./pages/HoroscopoVirgo";
import HoroscopoLibra from "./pages/HoroscopoLibra";
import HoroscopoEscorpio from "./pages/HoroscopoEscorpio";
import HoroscopoSagitario from "./pages/HoroscopoSagitario";
import HoroscopoCapricornio from "./pages/HoroscopoCapricornio";
import HoroscopoAcuario from "./pages/HoroscopoAcuario";
import HoroscopoPiscis from "./pages/HoroscopoPiscis";
import Contacto from "./pages/Contacto";
import FAQ from "./pages/FAQ";
import CalendarioLunar from "./pages/CalendarioLunar";
import Clientes from "./pages/Clientes";
import GuiaSignos from "./pages/GuiaSignos";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/horoscopo" element={<Horoscope />} />
            <Route path="/guia-signos" element={<GuiaSignos />} />
            <Route path="/horoscopo-chino" element={<HoroscopoChino />} />
            <Route path="/compatibilidad" element={<Compatibility />} />
            <Route path="/tarot" element={<Tarot />} />
            <Route path="/horoscopo-aries" element={<HoroscopoAries />} />
            <Route path="/horoscopo-tauro" element={<HoroscopoTauro />} />
            <Route path="/horoscopo-geminis" element={<HoroscopoGeminis />} />
            <Route path="/horoscopo-cancer" element={<HoroscopoCancer />} />
            <Route path="/horoscopo-leo" element={<HoroscopoLeo />} />
            <Route path="/horoscopo-virgo" element={<HoroscopoVirgo />} />
            <Route path="/horoscopo-libra" element={<HoroscopoLibra />} />
            <Route path="/horoscopo-escorpio" element={<HoroscopoEscorpio />} />
            <Route path="/horoscopo-sagitario" element={<HoroscopoSagitario />} />
            <Route path="/horoscopo-capricornio" element={<HoroscopoCapricornio />} />
            <Route path="/horoscopo-acuario" element={<HoroscopoAcuario />} />
            <Route path="/horoscopo-piscis" element={<HoroscopoPiscis />} />
            <Route path="/horoscopo-rata" element={<HoroscopoRata />} />
            <Route path="/horoscopo-buey" element={<HoroscopoBuey />} />
            <Route path="/horoscopo-tigre" element={<HoroscopoTigre />} />
            <Route path="/horoscopo-conejo" element={<HoroscopoConejo />} />
            <Route path="/horoscopo-dragon" element={<HoroscopoDragon />} />
            <Route path="/horoscopo-serpiente" element={<HoroscopoSerpiente />} />
            <Route path="/horoscopo-caballo" element={<HoroscopoCaballo />} />
            <Route path="/horoscopo-cabra" element={<HoroscopoCabra />} />
            <Route path="/horoscopo-mono" element={<HoroscopoMono />} />
            <Route path="/horoscopo-gallo" element={<HoroscopoGallo />} />
            <Route path="/horoscopo-perro" element={<HoroscopoPerro />} />
            <Route path="/horoscopo-cerdo" element={<HoroscopoCerdo />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/calendario-lunar" element={<CalendarioLunar />} />
            <Route path="/clientes" element={<Clientes />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
